import React from "react";
import SessionWizardModal from "./SessionWizardModal";
import { closeSessionWizardModal, useSessionWizardTrigger } from "./store";

export const SessionWizardHost: React.FC = () => {
  const trigger = useSessionWizardTrigger();
  if (!trigger) return null;
  return (
    <SessionWizardModal trigger={trigger} onClose={closeSessionWizardModal} />
  );
};

export { openSessionWizardModal, closeSessionWizardModal } from "./store";
